import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Acceso Inmediato',
    desc: 'Descarga el sistema completo en formato digital inmediatamente después de tu compra.'
  }, {
    num: '02',
    title: 'Fase de Emergencia',
    desc: 'Aplica el Protocolo de Emergencia para calmar tu sistema nervioso y detener el colapso emocional.'
  }, {
    num: '03',
    title: 'Reconstrucción',
    desc: 'Sigue la Hoja de Ruta de 90 días para reconstruir tu identidad y blindar tus límites para siempre.'
  }];
  return <section className="py-24 px-4 bg-dark-800" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <FadeIn data-id="element-80">
          <h2 className="text-3xl md:text-4xl text-center mb-16" data-id="element-81">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-82">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-gold/20" data-id="element-83" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-84">
              <div className="flex flex-col items-center text-center" data-id="element-85">
                <div className="w-24 h-24 rounded-full bg-dark-900 border border-gold/30 flex items-center justify-center mb-8 shadow-[0_0_20px_rgba(212,175,55,0.1)]" data-id="element-86">
                  <span className="text-3xl font-serif text-gold" data-id="element-87">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-xl mb-4 font-serif" data-id="element-88">{step.title}</h3>
                <p className="text-offwhite/70 font-light leading-relaxed" data-id="element-89">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}